import { observer } from 'mobx-react';
import { FC } from 'react';
import branchEditStore from '../../store/branchEditStore';
import { BRANCH_DELIVERY_CONDITION, SETTINGS_DELIVERY_TYPE } from 'src/types/branches';
import { getValidatedInputNumericValue } from 'src/utils/helpers';
import Input from 'src/view/components/Controls/Input/Input';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

const conditionOptions: IPickerOption[] = [
  { value: BRANCH_DELIVERY_CONDITION.DISABLED, label: 'branch_ds_switcher_value_disabled' },
  { value: BRANCH_DELIVERY_CONDITION.BY_LOCATION, label: 'branch_ds_switcher_value_by_location' },
  { value: BRANCH_DELIVERY_CONDITION.FIXED, label: 'branch_ds_switcher_value_fixed' },
];

interface IProps {
  status: BRANCH_DELIVERY_CONDITION;
  type: SETTINGS_DELIVERY_TYPE;
  fixedValue: string;
  onChangeStatus: (status: string | number) => void;
  onChangeFixedValue: (value: string, key?: 'delivery_fee' | 'order_more_than') => void;
}

const DeliveryConditionControls: FC<IProps> = observer(({ status, type, fixedValue, onChangeStatus, onChangeFixedValue }): JSX.Element => {
  const onChangeValue = (value: string, key?: 'delivery_fee' | 'order_more_than') => {
    const validatedValue = getValidatedInputNumericValue(value);
    if (validatedValue == null) return;
    if (key) {
      onChangeFixedValue(validatedValue, key);
      return;
    }
    onChangeFixedValue(validatedValue);
  };

  const isFixed = () => {
    return status === BRANCH_DELIVERY_CONDITION.FIXED;
  };

  const validationReduceDeliveryFee = () => branchEditStore.isValidationFailed && !branchEditStore.validation.deliverySettings.reduced.delivery_fee;

  return (
    <div className="d-flex mt-2 flex-column align-items-start">
      <TabPicker value={status} options={conditionOptions} onChange={onChangeStatus} />
      {isFixed() && type === SETTINGS_DELIVERY_TYPE.DELIVERY_FEE && (
        <div className="delivery-condition-controls__wrapper mt-2">
          <Text text="branch_delivery_fee_header" type={TEXT.LIST_ROW} />
          <Input
            value={fixedValue}
            className="delivery-condition-controls__input family-medium text-size-16"
            wrapperClassName="ml-2"
            onChangeText={onChangeValue}
          />
        </div>
      )}
      {isFixed() && type === SETTINGS_DELIVERY_TYPE.MIN_ORDER && (
        <div className="delivery-condition-controls__wrapper mt-2">
          <Text text="branch_min_order_header" type={TEXT.LIST_ROW} />
          <Input
            value={fixedValue}
            className="delivery-condition-controls__input family-medium text-size-16"
            wrapperClassName="ml-2"
            onChangeText={onChangeValue}
          />
        </div>
      )}
      {isFixed() && type === SETTINGS_DELIVERY_TYPE.REDUCED_DELIVERY_FEE && (
        <>
          <div className={`delivery-condition-controls__wrapper mt-2 ${validationReduceDeliveryFee() ? 'input-error' : ''}`}>
            <Text text="reduced_delivery_fee" type={TEXT.LIST_ROW} />
            <Input
              value={branchEditStore.editableBranch.reduced[0].delivery_fee}
              className="delivery-condition-controls__input family-medium text-size-16"
              wrapperClassName=""
              onChangeText={(text) => onChangeValue(text, 'delivery_fee')}
            />
          </div>
          {validationReduceDeliveryFee() ? <Text type={TEXT.ERROR} text="reduced_df_equal_or_more_df" /> : null}
          <div className="delivery-condition-controls__wrapper mt-2">
            <Text text="order_more_than" type={TEXT.LIST_ROW} />
            <Input
              value={branchEditStore.editableBranch.reduced[0].order_more_than}
              className="delivery-condition-controls__input family-medium text-size-16"
              wrapperClassName=""
              onChangeText={(text) => onChangeValue(text, 'order_more_than')}
            />
          </div>
        </>
      )}
    </div>
  );
});

export default DeliveryConditionControls;
